module.exports = __webpack_public_path__ + "static/018-3252132d900e7a166d0cfdebb1166ffa.jpg";